import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { ThemesVM } from '../themes.viewmodel';
import { IThemeDTO } from '../../../api/themes.dao';
import { ListLayout } from '../../global/tables/table-list-layout';
import TableLoadingRow from '../../global/tables/table-loading-row';
import DefaultButton from '../../global/default-button/default-button';
import { SearchInput } from '../../global/search-input/search-input';
import { ThemeListItem } from './_themes-list-item/theme-list-item';
import { EMPTY_SEARCH_RESULT } from '../../../constants/common-labels.constants';

interface IProps {
    intl: IntlShape;
    vm: ThemesVM;
}

const ThemesList = injectIntl(mobxReact.observer((props: IProps) => {
    const { intl, vm } = props;

    const emptySearchResult = !!(vm.themeName && !vm.themesList.length && !vm.isListLoading);

    const title = (
        intl.formatMessage(
            {
                id: 'oe.common.themes',
                defaultMessage: 'Themes',
                description: 'Label text'
            })
    );

    const thead = [
        intl.formatMessage(
            {
                id: 'oe.common.themeName',
                description: 'Label text',
                defaultMessage: 'Name',
            }),
        intl.formatMessage(
            {
                id: 'oe.common.themeStatus',
                description: 'Label text',
                defaultMessage: 'Status',
            }),
        <div className='search-input-container'>
            <SearchInput
                placeholder={intl.formatMessage({
                    id: 'oe.common.searchByName',
                    defaultMessage: 'Search by Name',
                    description: 'Search placeholder'
                })}
                resetSearch={vm.onThemeSearchReset}
                onChange={(e, value) => vm.onThemeSearch(value)}
                withResetSearchButton
                withDebounce
            />
        </div>
    ];

    return (
        vm.themesList &&
        <div className='page-container'>
            <section className='top-page-title horizontal-row horizontal-row--with-bottom-margin'>
                <h1 className='text-ellipsis'>{title}</h1>
                <div className='horizontal-row__align-to-row-end'>
                    <div className='buttons-block'>
                        <DefaultButton
                            className='events-list__button-new'
                            modifier='fat'
                            text={intl.formatMessage(
                                {
                                    id: `oe.theme.newTheme`,
                                    description: 'Placeholder text',
                                    defaultMessage: '{prefix}New Theme',
                                },
                                {
                                    prefix: '+ '
                                }
                            )}
                            onClick={() => vm.showThemeForm(intl.formatMessage(
                                {
                                    id: `oe.theme.newTheme`,
                                    description: 'Placeholder text',
                                    defaultMessage: '{prefix}New Theme',
                                },
                                {
                                    prefix: ''
                                }
                            ))}
                        />
                    </div>
                </div>
            </section>
            <section className='themes-list fixed-list-layout'>
                <div>
                    <ListLayout thead={thead}>
                        {vm.themesList.length
                            ? vm.themesList.map((theme: IThemeDTO, index) => {
                                return <ThemeListItem
                                    {...theme}
                                    key={index}
                                    intl={intl}
                                    searchInput={vm.themeName}
                                    isSelected={vm.isThemeEditFormShown(theme.id)}
                                    handleEditClick={vm.showEditTheme}
                                />;
                            })
                            : !vm.themeName && !vm.isListLoading && <TableLoadingRow colSpan={thead.length} contentLength={vm.themesList.length} />
                        }
                    </ListLayout>
                    {emptySearchResult &&
                        <div className='empty-list-message'>
                            <FormattedMessage {...EMPTY_SEARCH_RESULT} />
                        </div>
                    }
                </div>
            </section>
        </div>
    );
}));

export default ThemesList;
